import { render, staticRenderFns } from "./MevSettings.vue?vue&type=template&id=3f8e1ad0&scoped=true"
import script from "./MevSettings.vue?vue&type=script&lang=js"
export * from "./MevSettings.vue?vue&type=script&lang=js"
import style0 from "./MevSettings.vue?vue&type=style&index=0&id=3f8e1ad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8e1ad0",
  null
  
)

export default component.exports